module.exports = __webpack_public_path__ + "static/seven.palms-4db95605e05bfc7d1d9b0195415862aa.png";